

module.exports = __webpack_require__.stylable.create(
    "Focusable958207146",
    {"classes":{"root":"Focusable958207146__root","focus-box":"Focusable958207146__focus-box","focus-box-error":"Focusable958207146__focus-box-error"},"vars":{},"stVars":{},"keyframes":{}},
    ".Focusable958207146__focus-box{outline:0}.Focusable958207146__focus-box-error{outline:0}",
    1,
    "Focusable958207146",
    __webpack_require__.stylable.$
);
